<template>
  <div class="content">
    <v-tabs @change="tabChange()" v-model="tab">
      <v-tab>Caractéristiques de l'exercice</v-tab>
      <v-tab>Plan de Travail</v-tab>

      <v-spacer></v-spacer>

      <v-btn :loading="saving" :disabled="saving" @click="submitForm" style="color: white" color="#0F1547" class="m-1"> Sauvegarder </v-btn>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <div class="md-layout" style="background: #f1f1f1">
          <div class="md-layout-item md-medium-size-100 md-size-66">
            <exercise-form v-if="loaded" ref="exerciseFormComp" :key="updater" :load="load" data-background-color="blue" />
          </div>

          <div class="md-layout-item md-medium-size-100 md-size-33 pt-3">
            <div style="background: #fff; border: 2px solid #ccc; border-radius: 5px">
              <img :key="updater" class="img" :src="load.preview || cardUserImage" />
            </div>

            <v-card class="mt-5">
              <v-card-title class="headline" primary-title>
                <span> Médias </span>
                <v-spacer></v-spacer>
                <!-- Open my medias dialog -->
                <v-btn dark small color="#0F1547" v-on:click="openMyMediasDialog()">
                  <v-icon left dark>mdi-folder-multiple-image</v-icon>
                  Mes Médias
                </v-btn>
              </v-card-title>

              <v-card-text v-if="media.length > 0">
                <select-media-component
                  ref="selectMediaCompRef"
                  :_medias="media"
                  :_selectedMedias="selectedMedias"
                  v-on:onMediasSelected="onSelect"
                ></select-media-component>
              </v-card-text>
            </v-card>
          </div>
        </div>
      </v-tab-item>

      <v-tab-item>
        <exercise-paperboard :exerciseDraggables="load.exerciseDraggables" :exerciseId="id" :load="load" />
      </v-tab-item>
    </v-tabs-items>

    <!-- my medias dialog -->
    <v-dialog v-model="myMediasDialog" persistent>
      <v-card>
        <v-card-title>
          <h4>Mes Médias</h4>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeMyMediasDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid class="no-padding-sides">
            <v-row align-content="center">
              <v-col cols="12" class="no-padding-sides">
                <media />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!--Boutons dialog-->
          <v-btn color="blue darken-1" text @click="closeMyMediasDialog()">Terminé</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AuthService from "@/services/AuthService";
import { bus } from "@/main.js";
import { createExerciseAsync, updateExerciseAsync, getExerciseByIdAsync } from "@/api/exerciseApi";
import PermissionsService from "@/services/PermissionsService";
import ExercisePaperboard from "./ExercisePaperboard";
import ExerciseForm from "./ExerciseForm";
import { getAllMediasForCurrentUserAsync, getDownloadMediaByPathAsync } from "@/api/mediaApi";
import { exerciseDraggablesSqlToObject } from "@/transformers/exerciseDraggablesTransformers";
import store from "@/store";
import { DestinationType, ExerciseType } from "@/models/enums";
import SelectMediaComponent from "@/components/SelectMediaComponent";
import media from "@/components/Library/Media";

export default {
  props: {
    cardUserImage: {
      type: String,
      default: require("@/assets/Placeholder_image.jpg"),
    },
    id: {
      type: String,
      default: "0",
    },
  },

  components: {
    ExerciseForm,
    ExercisePaperboard,
    SelectMediaComponent,
    media,
  },

  data() {
    return {
      exerciseId: null,
      canvasSave: null,
      preview: null,
      photos: [],
      tab: null,
      image: this.cardUserImage,
      updater: 0,
      media: [],
      currentMedias: [],
      loaded: false,
      load: {
        medias: [],
        disciplineId: null,
        federationId: null,
        defaultFederationId: null,
        coachId: null,
        destinationType: DestinationType.UNDEFINED,
        exerciseType: ExerciseType.UNDEFINED,
      },
      saving: false,
      myMediasDialog: false,
    };
  },

  computed: {
    canManageCurrentExercise() {
      // Can manage own Exercises
      let canManageOwnExercises = PermissionsService.ExercisesPermissionsService.canManageOwnExercises && this.load && this.load.isAllowedToManageExercise;
      // Can manage all Exercises
      let canManageAllExercises = PermissionsService.ExercisesPermissionsService.canManageAllExercises;
      return canManageOwnExercises || canManageAllExercises;
    },
    selectedMedias: function () {
      return this.media.filter((media) => this.currentMedias.includes(media.id));
    },
  },

  async mounted() {
    // Init can manage flag with true, will be overriden by fetchExercise if not new exercise
    this.load.isAllowedToManageExercise = true;

    // First get the exercise
    if (this.id && this.id !== "0") {
      this.exerciseId = this.id;
      await this.fetchExercise(this.id);
    }
    // Else we still wanna load user medias
    else {
      await this.loadImage();
      this.loaded = true;
    }

    // Check if the user can see this page
    if (!this.canManageCurrentExercise) {
      store.dispatch("setSnackbar", {
        title: `Non Autorisé`,
        text: `Vous n'êtes pas autorisé à consulter cette ressource.`,
        status: "warning",
        timeout: 2000,
      });

      this.$router.replace("/");
    }

    //this.updater++;
  },

  watch: {
    $route(to, from) {
      const { params } = to;

      if (!params.id) {
        this.load = {};
      } else if (params.id !== from.params.id) {
        this.fetchExercise(params.id);
      }
    },
  },

  methods: {
    async fetchExercise() {
      // This function is blocking the display, so we need to start a loader for it and close it at the end
      // Increment the request counter for the loader
      store.dispatch("addRemoveRequest", true);

      if (!this.id || this.id === "0") {
        // Decrement the request counter for the loader
        store.dispatch("addRemoveRequest", false);

        return;
      }

      const exercise = await getExerciseByIdAsync(this.id);

      if (exercise != undefined) {
        exercise.medias = [];
        this.isReal = true;
        this.isPrerequis = true;

        // first we wanna init some properties in order to ckeditor to run without error
        if (exercise.descriptionHtml == null) {
          exercise.descriptionHtml = "";
        }
        if (exercise.instructionsHtml == null) {
          exercise.instructionsHtml = "";
        }
        if (exercise.materielHtml == null) {
          exercise.materielHtml = "";
        }

        // Empty only frontend experienceLevels property (used to handle ddl selected values)
        exercise.experienceLevels = [];
        // Get all the many many exerciseExperienceLevels values and map only the experienceLevel id into experienceLevels (filling the ddl with values)
        exercise.exerciseExperienceLevels.forEach((element) => {
          exercise.experienceLevels.push(element.experienceLevelId);
        });

        // Empty only frontend workForms property (used to handle ddl selected values)
        exercise.workForms = [];
        // Get all the many many exerciseWorkForms values and map only the workForm id into workForms (filling the ddl with values)
        exercise.exerciseWorkForms.forEach((element) => {
          exercise.workForms.push(element.workFormId);
        });

        // Empty only frontend skills property (used to handle ddl selected values)
        exercise.skills = [];
        exercise.selectedSkills = [];
        // Get all the many many exerciseSkills values and map only the workForm id into skills (filling the ddl with values)
        exercise.exerciseSkills.forEach((element) => {
          // Need to create a second property (selectedSkills) in order to pass it in the ExerciseForm view and reasign it to exercise.skills. Strange behavior but required.
          exercise.selectedSkills.push(element.skillId);
        });

        exercise.exerciseMedia &&
          exercise.exerciseMedia.forEach((element) => {
            exercise.medias.push(element.mediaId);
            this.currentMedias.push(element.mediaId);
          });

        await this.loadImage();
      }

      this.load = exercise;

      this.json = this.load && this.load.exerciseDraggables ? exerciseDraggablesSqlToObject(this.load.exerciseDraggables) : null;

      // Decrement the request counter for the loader
      store.dispatch("addRemoveRequest", false);

      this.loaded = true;
    },

    updateCanvas(canvas) {
      this.canvasSave = canvas;
    },

    async submitForm() {
      // Validate the inner form
      var isFormValid = this.$refs.exerciseFormComp.$refs.exerciseForm.validate();

      // If the form rules are validated
      if (isFormValid) {
        this.saving = true;

        await bus.$emit("beforeSaveExercise");

        const form = this.load;
        form.id = this.exerciseId;
        form.userId = AuthService.userId;
        delete form.discipline;

        form.exerciseMedia = form.medias.map((media) => ({ exerciceId: 0, mediaId: media }), []);

        // Handle Experience Level if exists (ddl)
        if (form.experienceLevels) {
          // Empty the many many property on Exercise
          form.exerciseExperienceLevels = [];
          // Add experience level id in a new many many object to be handled by the backend
          form.experienceLevels.forEach((exl) => {
            form.exerciseExperienceLevels.push({ experienceLevelId: exl });
          });
        }

        // Handle WorkForm if exists (ddl)
        if (form.workForms) {
          // Empty the many many property on Exercise
          form.exerciseWorkForms = [];
          // Add workform id in a new many many object to be handled by the backend
          form.workForms.forEach((exl) => {
            form.exerciseWorkForms.push({ workFormId: exl });
          });
        }

        // Handle Skill if exists (ddl)
        if (form.skills) {
          // Empty the many many property on Exercise
          form.exerciseSkills = [];
          // Add skill id in a new many many object to be handled by the backend
          form.skills.forEach((id) => {
            form.exerciseSkills.push({ skillId: id });
          });
          // Empty selectedSkills
          form.selectedSkills = null;
        }

        bus.$emit("excreated", form);
        const result = this.exerciseId !== null && this.exerciseId !== "0" ? await updateExerciseAsync(this.exerciseId, form) : await createExerciseAsync(form);

        // If we have an id > 0 in the result, the save succeeded
        if (result && result > 0) {
          var createdOrUpdatedMessage = form.id === null || form.id === "0" ? "créé" : "mis à jour";

          store.dispatch("setSnackbar", {
            title: `Exercice ${createdOrUpdatedMessage}`,
            text: `L'exercice a bien été ${createdOrUpdatedMessage}.`,
            status: "success",
            timeout: 2000,
          });
        }

        if (!this.exerciseId || this.exerciseId === "0") {
          this.exerciseId = result;
          this.$router.push(`/exercise/${this.exerciseId}`);
        }

        this.saving = false;
      }
      // Else display all the errors
      else {
        var exercise = this.load;

        // Handle missing title
        if (!exercise.title) {
          store.dispatch("setSnackbar", {
            title: "Titre requis",
            text: "Veuillez renseigner le Titre.",
            status: "error",
            timeout: 2000,
          });
        }
        // Handle missing exerciseType
        if (!exercise.exerciseType) {
          store.dispatch("setSnackbar", {
            title: "Type requis",
            text: "Veuillez renseigner le Type.",
            status: "error",
            timeout: 2000,
          });
        }
        // Handle missing destination
        if (!exercise.destinationType) {
          store.dispatch("setSnackbar", {
            title: "Destination requise",
            text: "Veuillez renseigner la Destination.",
            status: "error",
            timeout: 2000,
          });
        }

        // Handle missing discipline if destination specific selected
        if (exercise.destinationType === DestinationType.DISCIPLINE && !exercise.disciplineId) {
          store.dispatch("setSnackbar", {
            title: "Discipline requise",
            text: "La destination de l'exercice est Spécifique. Veuillez renseigner la discipline associée.",
            status: "error",
            timeout: 2000,
          });
        }
      }
    },

    tabChange() {
      bus.$emit("tabChange", this.tab);
    },

    async loadImage() {
      // Increment the request counter for the loader
      store.dispatch("addRemoveRequest", true);

      let list = await getAllMediasForCurrentUserAsync();
      const toReturn = [];
      for (let i = 0; i < list.length; i++) {
        let url = list[i].url;
        if (url) {
          const urlCreator = window.URL || window.webkitURL;
          let response;
          let result;
          switch (list[i].typeId) {
            case 1:
              response = await getDownloadMediaByPathAsync(url);
              if (!response) break;
              result = await response.blob();
              list[i].src = urlCreator.createObjectURL(result);
              toReturn.push({
                id: list[i].id,
                src: urlCreator.createObjectURL(result),
                alt: list[i].name,
                mediaType: list[i].mediaType,
              });
              break;
            case 2:
              response = await getDownloadMediaByPathAsync(url);
              if (!response) break;
              result = await response.blob();
              list[i].image = require("@/assets/Placeholder_video.jpg");
              list[i].videoOptions = {
                techOrder: ["html5", "youtube"],
                autoplay: false,
                controls: true,
                responsive: true,
                sources: [
                  {
                    src: urlCreator.createObjectURL(result),
                    type: response.headers.get("Content-Type"),
                  },
                ],
              };
              toReturn.push({
                id: list[i].id,
                src: require("@/assets/Placeholder_video.jpg"),
                alt: list[i].name,
                mediaType: list[i].mediaType,
              });

              break;
            case 3:
              response = await getDownloadMediaByPathAsync(url);
              if (!response) break;
              result = await response.blob();
              list[i].image = require("@/assets/Placeholder_fichier.jpg");
              list[i].file = urlCreator.createObjectURL(result);
              toReturn.push({
                id: list[i].id,
                src: require("@/assets/Placeholder_fichier.jpg"),
                alt: list[i].name,
                mediaType: list[i].mediaType,
              });
              break;
            case 4:
              list[i].image = require("@/assets/Placeholder_lien.jpg");
              const parse = require("url-parse");
              const parsed = parse(url, true);
              const youtubeRegex = /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/gim;
              const pictureRegex = /http[s]?:\/\/.+\.(jpeg|png|jpg|gif)/gim;
              list[i].src = url;
              if (parsed.hostname.includes("canal-sport") && parsed.pathname.endsWith("player")) list[i].canal = true;
              else if (youtubeRegex.exec(url)) {
                list[i].youtube = true;
                list[i].videoOptions = {
                  techOrder: ["html5", "youtube"],
                  autoplay: false,
                  controls: true,
                  responsive: true,
                  sources: [
                    {
                      src: url,
                      type: "video/youtube",
                    },
                  ],
                };
              } else if (pictureRegex.exec(url)) {
                list[i].isImage = true;
                list[i].image = url;
              }

              toReturn.push({
                id: list[i].id,
                src: require("@/assets/Placeholder_lien.jpg"),
                alt: list[i].name,
                mediaType: list[i].mediaType,
              });
              break;
            default:
              break;
          }
        }
      }

      // decrement the request counter for the loader
      store.dispatch("addRemoveRequest", false);

      this.media = toReturn;
    },

    // Open my medias dialog
    openMyMediasDialog() {
      this.myMediasDialog = true;
    },

    // Close my medias dialog and update child select media component medias
    async closeMyMediasDialog() {
      // Reload available images
      await this.loadImage();
      // Force update child select media component data
      if (this.$refs.selectMediaCompRef) {
        await this.$refs.selectMediaCompRef.completeInit();
      }

      // Close the dialog
      this.myMediasDialog = false;
    },

    onSelect(item) {
      this.load.medias = [];

      item.forEach((med) => {
        this.load.medias.push(med.id);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.md-layout {
  padding-bottom: 10px !important;
}
</style>
